import type { IconList } from '@snowit/assets';
import type { ProductTypeEnum } from '@snowit/models';
import type { MainNavRoute, MainPath, MainRoute } from '../types';

import PERMISSIONS from '@snowit/utilities/permissions';

export const DEALERS_TABS = [
  'experience',
  'experience~museum',
  'food',
  'lesson',
  'parking',
  'rental',
  'rental~bike',
  'pickup',
  'transport',
  'transport~ferry',
] as const satisfies (ProductTypeEnum | 'pickup')[];

export const PROVIDERS_TABS = [
  'hotel',
  'experience',
  'experience~museum',
  'food',
  'lesson',
  'rental',
  'rental~bike',
  'skipass',
  'skipass~return',
  'transport',
] as const satisfies ProductTypeEnum[];

const DEALERS_PERMS: Record<DealersTabs, PERMISSIONS[]> = {
  experience: [PERMISSIONS.DEALER_ORDERS__EXPERIENCE],
  'experience~museum': [PERMISSIONS.DEALER_ORDERS__EXPERIENCE_MUSEUM],
  food: [PERMISSIONS.DEALER_ORDERS__FOOD],
  lesson: [PERMISSIONS.DEALER_ORDERS__LESSON],
  parking: [PERMISSIONS.DEALER_ORDERS__PARKING],
  rental: [PERMISSIONS.DEALER_ORDERS__RENTAL],
  'rental~bike': [PERMISSIONS.DEALER_ORDERS__RENTAL_BIKE],
  pickup: [PERMISSIONS.DEALER_ORDERS__PICKUP],
  transport: [PERMISSIONS.DEALER_ORDERS__TRANSPORT],
  'transport~ferry': [PERMISSIONS.DEALER_ORDERS__TRANSPORT_FERRY],
};

const PROVIDER_PERMS: Record<ProvidersTabs, PERMISSIONS[]> = {
  hotel: [PERMISSIONS.PROVIDER_ORDERS__HOTEL],
  experience: [PERMISSIONS.PROVIDER_ORDERS__EXPERIENCE],
  'experience~museum': [PERMISSIONS.PROVIDER_ORDERS__EXPERIENCE_MUSEUM],
  food: [PERMISSIONS.PROVIDER_ORDERS__FOOD],
  lesson: [PERMISSIONS.PROVIDER_ORDERS__LESSON],
  rental: [PERMISSIONS.PROVIDER_ORDERS__RENTAL],
  'rental~bike': [PERMISSIONS.PROVIDER_ORDERS__RENTAL_BIKE],
  skipass: [PERMISSIONS.PROVIDER_ORDERS__SKIPASS],
  'skipass~return': [PERMISSIONS.PROVIDER_ORDERS__SKIPASS_RETURN],
  transport: [PERMISSIONS.PROVIDER_ORDERS__TRANSPORT],
};

export const DealersPath: MainPath = '/dealers/:type';
export const ProvidersPath: MainPath = '/providers/:type';

export type DealersTabs = (typeof DEALERS_TABS)[number];
export type ProvidersTabs = (typeof PROVIDERS_TABS)[number];

export const DealersRoutes: MainNavRoute[] = DEALERS_TABS.map((type) => ({
  path: `/dealers/${type}` as `/${MainRoute}`,
  label: `const.${type}`,
  icon: type as IconList,
  type: 1,
  permissions: DEALERS_PERMS[type],
}));

export const ProvidersRoutes: MainNavRoute[] = PROVIDERS_TABS.map((type) => ({
  path: `/providers/${type}` as `/${MainRoute}`,
  label: `const.${type}`,
  icon: type as IconList,
  type: 1,
  permissions: PROVIDER_PERMS[type],
}));

export const TrenitaliaRoute: MainNavRoute = {
  path: '/providers/trenitalia' as `/${MainRoute}`,
  label: 'routes.trenitalia',
  icon: 'train',
  type: 1,
  permissions: [PERMISSIONS.PROVIDER_ORDERS__TRENITALIA],
};
